import { Col, Container, Row } from 'react-bootstrap';
import ReactPlayer from 'react-player';

import { getImageUrl } from '@website/components/media/utils/imgix';
import { useWindowSize } from '@website/hooks/useWindowsSize';
import { TripsPageQuery } from '@website/types/graphqlOperations';

type TripVideoHighlightsProps = {
  trip: TripsPageQuery['tripByURL'];
};

export default function TripVideoHighlights({
  trip,
}: TripVideoHighlightsProps) {
  const { width } = useWindowSize();

  const isMobile = width < 576;

  if (!trip.tripVideoURL || !isMobile) {
    return null;
  }

  return (
    <Container className="g-0 pb-5 pt-3 px-2">
      <h2 className="mb-3" data-cy="itinerary-item-header">
        Highlights in 60 seconds
      </h2>
      <Row>
        <Col xs={12} sm={12} md={8} lg={6}>
          <div className="ratio ratio-16x9">
            <ReactPlayer
              height="100%"
              width="100%"
              url={trip.tripVideoURL}
              controls
              playing
              playIcon={<></>}
              light={
                trip.tripVideoURLThumbnail?.file?.key
                  ? getImageUrl(trip.tripVideoURLThumbnail?.file?.key)
                  : true
              }
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
